module.exports = __webpack_public_path__ + "img/52.ea16a700.jpg";